import {
  HOUR,
  isUnassignedTeamId,
  type TeamGetInput,
  type TeamGetSuccess,
  type TeamId,
  type TinyTeam,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { tinyTeamKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { useTeamCache } from './cache'

const EMPTY_TEAM_ID: TeamId = 'Team:EMPTY_TEAM'
export const useTinyTeam = (teamId: TeamId | undefined = EMPTY_TEAM_ID): GetHookResponse<TinyTeam> => {
  const cache = useTeamCache()

  return useTantalimQuery<TeamGetInput, TeamGetSuccess, TinyTeam>({
    url: '/team/get',
    queryKey: tinyTeamKey(teamId),
    input: {
      teamId,
    },
    convertResponse: (data) => {
      cache.setTeam(data.team)
      return data.team
    },
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled: teamId !== EMPTY_TEAM_ID && !isUnassignedTeamId(teamId),
    },
  })
}
